import { BRIEF_DEBUG_DATA_VISIBLE } from 'src/lib/featureFlags';

export interface ACDebugContext {
  traceAuthorComplete: boolean;
  traceAuthorCompleteTitle: string;
}

export const prepareACDebugContext = (
  name: string,
  params: Record<string, unknown>
): ACDebugContext | undefined => {
  if (!BRIEF_DEBUG_DATA_VISIBLE) {
    return;
  }

  const title = `"${name}" request [${JSON.stringify(params)}]`;
  return { traceAuthorComplete: true, traceAuthorCompleteTitle: title };
};
